import type { OrganizationRoleEnum } from '@models/enums';
import type { AuthUserInfo } from '@modules/auth/store';

export const transformUserInfo = (authInfo: AuthUserInfo) => {
    const obj = {
        ...authInfo,
    };

    if (obj?.account?.logo_url) {
        obj.account.logo_url = `${obj.account.logo_url}?t=${new Date().getTime()}`;
    }

    if (obj?.account?.global_role) {
        obj.account.global_role = obj.account.global_role?.toUpperCase() as OrganizationRoleEnum;
    }

    return obj;
};
